import util from '../util'

let controller = 'CorrentistaPJSocio'
export default Object.assign({}, util.GetCrud(controller, null))